import { render, staticRenderFns } from "./deleted-items-list.vue?vue&type=template&id=48fd316e&"
import script from "./deleted-items-list.vue?vue&type=script&lang=js&"
export * from "./deleted-items-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports